<template>
  <div class="BottomNavigation">
    <div class="container">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <div class="logo-section">
            <img @click="tabsIndex(-1, '/')" class="logo" src="../assets/logopc.png">
            <div class="nav-links">
              <div class="nav-column">
                <p @click="tabsIndex(0, '/about')">关于我们</p>
                <p @click="tabsIndex(1, '/news')">仓谷动态</p>
                <p @click="tabsIndex(2, '/business')">主营业务</p>
                <p @click="tabsIndex(5, '/franchise')">我要加盟</p>
              </div>
              <div class="nav-column">
                <p @click="tabsIndex(3, '/cooperation')">合作与生态</p>
                <!-- <p @click="tabsIndex(4, '/investor')">投资者关系</p> -->
                <p @click="tabsIndex(4, '/Joinus')">加入我们</p>
              </div>
            </div>
          </div>

        </el-col>


        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="contact-section">
            <div class="contact-item">服务热线</div>
            <div class="contact-item phone">400-622-1988</div>
            <div class="contact-item">公司地址</div>
            <div class="contact-item address">地址：浙江省丽水市莲都区古城路163-165号</div>
          </div>
        </el-col>
        
        <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <div class="qrcode-section">
            <div class="qrcode-item">
              <img src="../assets/cgQRCode.png" alt="微信公众号">
              <p>微信公众号</p>
            </div>
            <div class="qrcode-item">
              <img src="../assets/rzwQRCode.png" alt="微信公众号">
              <p>微信公众号</p>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>


  <div class="beian">
    <div class="beian-content">
      <img src="../../public/img/icp.png" alt="ICP备案" />
      <p>
        <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33110202000709">浙公网安备
          33110202000709号</a>
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备14007572号-6</a>
        @2023 浙江仓谷数字技术股份有限公司 版权所有
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useStore } from "@/store";
const store = useStore();
const router = useRouter();
const tabsIndex = (index, url) => {
  store.curIndex = index
  if (!url) {
    return
  }

  router.push(url)
}
</script>

<style scoped lang="scss">
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo-section {
  .logo {
    width: 140px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .nav-links {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;

    .nav-column {
      p {
        cursor: pointer;
        margin-bottom: 8px;
        font-size: 14px;
        color: #FFFFFF;

        &:hover {
          color: #E0E0E0;
        }
      }
    }
  }
}

.qrcode-section {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  .qrcode-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 107px;
      height: 107px;
    }

    p {
      color: #ffffff;
      font-size: 16px;
      text-align: center;
      margin-top: 14px;
    }
  }
}

.contact-section {
  .contact-item {
    color: white;
    margin-bottom: 12px;
    font-size: 14px;

    &.phone {
      font-size: 26px;
    }

    &.address {
      line-height: 1.4;
    }
  }
}

.beian {
  font-size: 15px;
  text-align: center;
  padding: 20px 5px;
  background-color: #18181A;
  color: #FFFFFF;

  .beian-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;

    img {
      float: left;
    }

    p {
      float: left;
      height: 20px;
      line-height: 20px;
      margin: 0;
      color: #939393;

      a {
        color: #939393;
        margin-left: 10px;

        &:first-child {
          margin-left: 0;
        }

        &:hover {
          color: #FFFFFF;
        }
      }
    }
  }
}

.BottomNavigation {
  width: 100%;
  background-color: #18181A;
  padding: 44px 0;
}

// 响应式调整
@media (max-width: 768px) {
  .BottomNavigation {
    padding: 30px 0;
  }

  .logo-section {
    .logo {
      width: 120px;
      margin-bottom: 15px;
    }

    .nav-links {
      gap: 30px;

      .nav-column {
        p {
          font-size: 13px;
          margin-bottom: 6px;
        }
      }
    }
  }

  .qrcode-section {
    .qrcode-item {
      img {
        width: 90px;
        height: 90px;
      }

      p {
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }

  .contact-section {
    .contact-item {
      margin-bottom: 10px;
      font-size: 13px;

      &.phone {
        font-size: 22px;
      }
    }
  }

  .beian {
    padding: 15px 5px;
    font-size: 13px;

    .beian-content {
      flex-direction: column;
      gap: 10px;

      img {
        float: none;
      }

      p {
        float: none;
        height: auto;
        line-height: 1.4;
        text-align: center;
      }
    }
  }
}

@media (max-width: 480px) {
  .BottomNavigation {
    padding: 20px 0;
  }

  .container {
    padding: 0 15px;
  }

  .logo-section {
    .logo {
      width: 100px;
      margin-bottom: 10px;
    }

    .nav-links {
      gap: 20px;

      .nav-column {
        p {
          font-size: 12px;
        }
      }
    }
  }

  .qrcode-section {
    .qrcode-item {
      img {
        width: 80px;
        height: 80px;
      }

      p {
        font-size: 12px;
        margin-top: 8px;
      }
    }
  }

  .contact-section {
    .contact-item {
      &.phone {
        font-size: 18px;
      }
    }
  }

  .beian {
    font-size: 12px;
  }
}
</style>
